import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { Grid } from "@mui/material";
import Buttons from "../../../../components/Form/Button/Button";
import moment from "moment-timezone";
import { countries } from "../../../../assets/data/countries";
import { truncateText } from "../../../../hooks/HelperFunctions";

// ================= Table OD and EVEN Code ========//
const StyledTableCell = withStyles((theme) => ({
  root: {
    fontWeight: 600,
    color: "#5C677D",
    width: "200px",
    [theme.breakpoints.down("lg")]: {
      minWidth: "150px",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "150px",
    },
  },
}))(TableCell);
const StyledTableCellTwo = withStyles((theme) => ({
  root: {
    fontWeight: 600,
    color: "#5C677D",
    borderRadius: "16px",
    // minWidth: "250px",
    // [theme.breakpoints.down("lg")]: {
    //   minWidth: "150px",
    // },
    // [theme.breakpoints.down("md")]: {
    //   minWidth: "150px",
    // },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid #e8eaed",
    borderTop: "1px solid #e8eaed",
    "&:last-child": {
      borderBottom: "0px !important",
    },
    // "&:nth-of-type(even)": {
    //   backgroundColor: "#FCFCFC",
    // },
  },
}))(TableRow);
// ================= Table OD and EVEN Code ========//

const OverviewTables = ({ studentDetails }) => {
  //============= copy part start ===================================//
  const handleCopyCode = (data) => {
    if (data === undefined) {
      navigator.clipboard.writeText("No data");
    } else {
      navigator.clipboard.writeText(data);
    }
  };
  //============= copy part start ===================================//

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item sm={12} md={12} lg={6}>
          {/* ====================== Access Details Table ======================= */}
          <div
            className="TableContainer oddEvenTable"
            style={{
              overflow: "hidden",
              borderRadius: "12px",
              border: "1px solid #e8eaed",
            }}
          >
            <div
              className="TableInnerHeader"
              style={{
                // borderTop: "1px solid #e8eaed",
                borderBottom: "0px",
                padding: "12px",
                color: "#5C677D",
                textTransform: "uppercase",
              }}
            >
              <h3>Personal details</h3>
            </div>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="left" className="TableLabel">
                      Name
                    </StyledTableCell>
                    <StyledTableCellTwo align="left" className="TableInfo">
                      {/* <div
                        className="cellwithchip"
                        style={{
                          color: "#0B132B",
                          fontWeight: "600",
                          margin: "0px",
                        }}
                      > */}
                      {/* <div className="VerifyChip">
                      <VerifiedRoundedIcon /> Verified
                    </div> */}
                      {/* </div> */}
                      {truncateText(
                        `${studentDetails?.firstName} ${studentDetails?.lastName}`,
                        40
                      )}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Gender</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.gender
                        ? studentDetails?.gender
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Birthday</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {" "}
                      {studentDetails?.birthDate
                        ? `**/**/${moment(studentDetails.birthDate).format(
                            "YYYY"
                          )}`
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <br />
          {/* ====================== Contact Table ======================= */}
          <div
            className="TableContainer oddEvenTable"
            style={{
              overflow: "hidden",
              borderRadius: "12px",
              border: "1px solid #e8eaed",
            }}
          >
            <div
              className="TableInnerHeader"
              style={{
                // borderTop: "1px solid #e8eaed",
                borderBottom: "0px",
                padding: "12px",
                color: "#5C677D",
                textTransform: "uppercase",
              }}
            >
              <h3>Contact</h3>
            </div>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="left" className="TableLabel">
                      Email
                    </StyledTableCell>
                    <StyledTableCellTwo align="left" className="TableInfo">
                      <div
                        className="cellwithchip"
                        style={{ color: "#0B132B", fontWeight: "600" }}
                      >
                        {studentDetails?.email
                          ? studentDetails?.email
                          : "No Data"}
                        <VerifiedRoundedIcon
                          fontSize="small"
                          sx={{ color: "#0450E1" }}
                        />
                      </div>
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Phone number</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.phone
                        ? studentDetails?.phone
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Country</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.country
                        ? countries?.find(
                            (country) =>
                              country.value === studentDetails.country
                          )?.label
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Address</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.address?.label
                        ? studentDetails?.address?.label
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Grid>
        <Grid item sm={12} md={12} lg={6}>
          {/* ====================== Academics Table ======================= */}
          <div
            className="TableContainer oddEvenTable"
            style={{
              overflow: "hidden",
              borderRadius: "12px",
              border: "1px solid #e8eaed",
            }}
          >
            <div
              className="TableInnerHeader"
              style={{
                // borderTop: "1px solid #e8eaed",
                borderBottom: "0px",
                padding: "12px",
                color: "#5C677D",
                textTransform: "uppercase",
              }}
            >
              <h3>Academics</h3>
            </div>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="left" className="TableLabel">
                      School
                    </StyledTableCell>
                    <StyledTableCellTwo align="left" className="TableInfo">
                      <div
                        className="cellwithchip"
                        style={{ color: "#0B132B", fontWeight: "600" }}
                      >
                        {" "}
                        {studentDetails?.schoolName
                          ? studentDetails?.schoolName
                          : "No Data"}
                      </div>
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Student ID</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      className="TableInfo accessDetailsPasswordRow"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.userUniqueID
                        ? studentDetails?.userUniqueID
                        : "No Data"}
                      <div style={{ paddingRight: "8px" }}>
                        <Buttons
                          label="Copy"
                          icon={<ContentCopyOutlinedIcon fontSize="small" />}
                          buttonColor=""
                          border="#C6C6D0 1px solid"
                          color="#5423FF"
                          width=""
                          height="28px"
                          fontSize="14px"
                          onClick={(e) =>
                            handleCopyCode(studentDetails?.userUniqueID)
                          }
                        />
                      </div>
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">NYSED ID #</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      className="TableInfo accessDetailsPasswordRow"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.nysedId
                        ? studentDetails?.nysedId
                        : "No Data"}
                      <div style={{ paddingRight: "8px" }}>
                        <Buttons
                          label="Copy"
                          icon={<ContentCopyOutlinedIcon fontSize="small" />}
                          buttonColor=""
                          border="#C6C6D0 1px solid"
                          color="#5423FF"
                          width=""
                          height="28px"
                          fontSize="14px"
                          onClick={(e) =>
                            handleCopyCode(studentDetails?.nysedId)
                          }
                        />
                      </div>
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">
                      Current class/level
                    </StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {" "}
                      {studentDetails?.currentClassLevel
                        ? studentDetails?.currentClassLevel
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">
                      Graduation Year
                    </StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.graduationYear
                        ? `${studentDetails?.graduationLevel} - CLASS OF ‘${studentDetails?.graduationYear}`
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell align="left">Joined date</StyledTableCell>
                    <StyledTableCellTwo
                      align="left"
                      style={{ color: "#0B132B", fontWeight: "600" }}
                    >
                      {studentDetails?.createdAt
                        ? moment(studentDetails?.createdAt).format(
                            "DD-MMM-YYYY"
                          )
                        : "No Data"}
                    </StyledTableCellTwo>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default OverviewTables;
